 import { beneficiarySchema } from "../schema/beneficiary.schema";
 import { currencySchema } from "../schema/currency.schema";
 import { deliveryMethodSchema } from "../schema/delivery-method.schema";

 export const TRANSACTIONQUERY = `query ($userId: String!, $meta: RequestEntityMetaIn!,$refine: Refinement) {
    findTransactions(userId: $userId, meta: $meta, refine: $refine) {
     count
     transactions {
      creationDateTime
      transactionId
      referenceNo
      userId
      passedCompliance
      interswitchDomain {
        selectedPaymentItem {
          paymentCode
          rtgsPaymentCode
        }
        customer {
          transactionRef
          category
          rtgsPaymentCode
          isAmountFixed
          surcharge
          amount
          paymentItem
          paymentItemId
          excise
          balance
          balanceNarration
          customerEmail
          alternateCustomerId
          address
          thirdPartyCode
          surchargeType
          balanceType
          displayBalance
          customerName
          responseCode
          biller
          collectionsAccountNumber
          narration
          collectionsAccountType
          paymentCode
          customerId
          customerMobile
          requestReference
          terminalId
          itemCode
          bankCbnCode
          deviceTerminalId
          customerToken
          transactionCode
          appVersion
        }
      }
      cashPickup {
        secretQuestion
        secretAnswer
      }
      paymentStatus {
        value
        label
      }
      status{
        value
        label
      }
      remittance {
        sourceOfIncome
        paymentMethod
        discount{
          id
          userId
          type
          description
          shortText
          value
          count
          expiryDate
          createdDateTime
        }
        deliveryMethod {
          ${deliveryMethodSchema}
        }
        purpose
        includeFee
        spread {
          amount
          currency {
           ${currencySchema}
          }
        }
        pay {
          amount
          currency {
           ${currencySchema}
          }
        }
        fee {
          amount
          currency {
            ${currencySchema}
          }
        }
        settlement {
          amount
          currency {
            ${currencySchema}
          }
        }
        remit{
          amount
          currency {
            ${currencySchema}
          }
        }
        sourceCurrency {
          ${currencySchema}
        }
        targetCurrency {
          ${currencySchema}
        }   
      }
      payment {
        url
        bankTransfer {
          accountName
          bank
          sortCode
          accountNumber
        }
        bank {
          alias
          country {
            code
            description
          }
          logoUrl
          currency {
            code
            description
          }
          aspspUuid
          dateCreated
          lastUpdated
        }
        paymentRequest {
          type
          myRef
          amount
          expiry
          icanTo
          currency
          returnUrl
          description
          orderDetails {
            orderId
            comment1
            comment2
            productId
            customerNumber
            variableReference
            merchantCustomerIdentification
          }
        }
        paymentReceived {
          to {
            type
            account {
              id
              nsc
              alias
              accountNumber
            }
          }
          bank {
            alias
            country {
              code
              description
            }
            logoUrl
            currency {
              code
              description
            }
            aspspUuid
            dateCreated
            lastUpdated
          }
          type
          myRef
          status
          currency {
            code
            description
          }
          feeAmount
          returnUrl
          endToEndId
          dateCreated
          description
          lastUpdated
          paymentUuid
          orderDetails {
            orderId
            comment1
            comment2
            productId
            customerNumber
            variableReference
            merchantCustomerIdentification
          }
          relatedPayeeId
          allowFopReceipt
          transactionType
          dateFundsReceived
          domesticPaymentId
          amountAfterCharges
          paymentRequestCode
          amountBeforeCharges
          relatedAccountTxnId
        }
        paymentAuthorised {
          to {
            type
            account {
              id
              nsc
              alias
              accountNumber
            }
          }
          bank {
            alias
            country {
              code
              description
            }
            logoUrl
            currency {
              code
              description
            }
            aspspUuid
            dateCreated
            lastUpdated
          }
          type
          myRef
          status
          currency {
            code
            description
          }
          feeAmount
          returnUrl
          endToEndId
          dateCreated
          description
          lastUpdated
          paymentUuid
          orderDetails {
            orderId
            comment1
            comment2
            productId
            customerNumber
            variableReference
            merchantCustomerIdentification
          }
          relatedPayeeId
          allowFopReceipt
          transactionType
          dateFundsReceived
          domesticPaymentId
          amountAfterCharges
          paymentRequestCode
          amountBeforeCharges
          relatedAccountTxnId
        }
      }
      beneficiary {
        ${beneficiarySchema}
      }
     }
      }
   }
`;
